import { buildBinderListings } from '@monofe/di';
import bindApi from './api/private/bind';
import bindController from './controller/private/bind';
import bindDB from './db/private/bind';
import bindJobs from './jobs/private/bind';
import bindModel from './model/bind';
import bindSession from './session/private/bind';
import bindUtil from './util/private/bind';

/* List of binders sorted in order of installation */
const bindablesPrivate = [bindUtil, bindApi, bindDB, bindController];
const bindablesPublic = [bindSession, bindModel, bindJobs];

const listings = buildBinderListings([...bindablesPublic, ...bindablesPrivate]);
export default listings;
